<template>
  <div
    class="font-weight-bold small pt-3 category-container container-sm text-center"
    id="category_container"
  >
    <div
      class="d-inline-block menu-item-container"
      v-for="(category,index) in menu.categories"
      :key="index"
    >
      <a
        v-if="(!user.id && category.items.length) || user.id"
        v-bind:class="{selected: selectedCategory == category.slug}"
        class="py-2 px-2 mx-2 text-uppercase animate__animated animate__fadeIn menu-item"
        v-on:click="$emit('scrollTo',categoryIdPrefix+category.slug)"
        ref="menuItem"
        v-bind:id="'menu_cat_' + category.slug"
        v-bind:data-category="category.slug"
      >{{ category.name }}</a>
    </div>
  </div>
</template>

<script>
import menuMixin from "../../../mixins/menuMixin";
export default {
  updated() {
    _.forEach(this.$refs.menuItem, function (value) {
      if (_.includes(value.classList, "selected")) {
        document.getElementById("category_container").scrollTo({
          top: 0,
          left: value.offsetLeft - 32,
          behavior: "smooth",
        });
      }
    });
  },
  data() {
    return {
      onboard: {
        category: true,
        item: true,
      },
    };
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    selectedCategory: {
      required: true,
    },
  },
  mixins: [menuMixin],
};
</script>
